var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPrecipitation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13a3.5 3.5 0 0 0 3.498-3.623L21 9.25h-.009a3.502 3.502 0 0 0-2.293-3.04A6.001 6.001 0 0 0 7.553 4H7.5a4.5 4.5 0 0 0 0 9h10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPrecipitation);
export default __webpack_public_path__ + "static/media/ic_action_precipitation.c1c6793b22e57b41f1120cf8c12af0b0.svg";
export { ForwardRef as ReactComponent };